import { ApplicationManagerMap } from '@core/typings/application.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ApplicationManagerState extends BaseYcState {
  readonly applicationManagerMap: ApplicationManagerMap = {};
  readonly triggerResetAppManagerTable: void;
  readonly hasMaskedAppsOnPage: boolean;
}
